export default __webpack_public_path__ + "static/media/wcag2.1AA.cf958269.png";